var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85714 0C1.28125 0 0 1.28125 0 2.85714V17.1429C0 18.7188 1.28125 20 2.85714 20H17.1429C18.7188 20 20 18.7188 20 17.1429V2.85714C20 1.28125 18.7188 0 17.1429 0H2.85714ZM6.90625 4.31696C7.33929 4.20089 7.79464 4.41964 7.96429 4.83482L8.85714 6.97768C9.00893 7.34375 8.90179 7.76339 8.59822 8.01339L7.5 8.91518C8.24107 10.4866 9.51339 11.7589 11.0848 12.5L11.9866 11.3973C12.2366 11.0938 12.6563 10.9866 13.0223 11.1384L15.1652 12.0312C15.5804 12.2054 15.7991 12.6563 15.683 13.0893L15.1473 15.0536C15.0402 15.4464 14.6875 15.7143 14.2857 15.7143C8.76339 15.7143 4.28571 11.2366 4.28571 5.71429C4.28571 5.3125 4.55357 4.95982 4.94196 4.85268L6.90625 4.31696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.55c52e319cafc3e1d222b9d0d2c6a626.svg";
export { ForwardRef as ReactComponent };